var map = {
	"./01-horniman-museum/map.svg": "9ddb",
	"./02-barbican/map.svg": "9305",
	"./03-culpeper/map.svg": "7dd8",
	"./04-kyoto/map.svg": "6640",
	"./05-isabella/map.svg": "6fe8",
	"./06-hillyfields/map.svg": "0b53",
	"./07-crystalpalace/map.svg": "b1e2",
	"./08-goldershill/map.svg": "be33",
	"./09-wormwood/map.svg": "ce5e",
	"./10-northgreenwich/map.svg": "f58b",
	"./11-osterleypark/map.svg": "d667",
	"./12-woodberrywetlands/map.svg": "869f",
	"./13-haggerston/map.svg": "58aa",
	"./14-boilergarden/map.svg": "e828",
	"./15-gaiasgarden/map.svg": "8468f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "851f";